import React from 'react';
import 'styles/css/accordion.scss'
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import HttpClient from "services/HttpClient";
import { SingleDatePicker } from 'react-dates';
import 'rc-time-picker/assets/index.css';
import 'react-dates/lib/css/_datepicker.css';
import Autosuggest from 'react-autosuggest';
import moment from 'moment';

const GET_PROVIDERS = '/api/v1/exports/users_list?query=';
const GET_WORKSHOPS = '/api/v1/exports/workshops_list?query=';
const GET_PROVIDER_EXPORT = '/api/v1/exports/provider?';
const GET_WORKSHOP_EXPORT = '/api/v1/exports/workshop?';

@inject('user')
@inject("alert")
@observer
export default class Reports extends React.Component {

  state = {
    focusedInput: false,
    date: null,
    providerReport: false,
    provider: '',
    workshop: '',
    providers: [],
    workshops: [],
    selectedId: 0,
  };

  handleProviderChange = (event, { newValue }) => {
    this.setState({provider: newValue, workshop: ''});
  }

  handleChangeWorkshop = (event, { newValue }) => {
    this.setState({workshop: newValue, provider: ''});
  }

  onWorkshop = () => {
    this.setState({providerReport: false, workshop: '', date: null, selectedId: 0});
  }

  onProvider = () => {
    this.setState({providerReport: true, provider: '', date: null, selectedId: 0});
  }

  onSuggestionsFetchRequested = async ({ value }) => {
    const providers = await this.getProviderSuggestions(value);
    this.setState({
      providers,
    });
  };

  onSuggestionsFetchWorkshops = async ({value}) => {
    const workshops = await this.getWorkshopSuggestions(value);
    this.setState({
      workshops,
    });
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      providers: [],
      workshops: [],
    });
  };

  getUsersList = query => {
    return new HttpClient().get(GET_PROVIDERS + query).then(data => data.body.data.users);
  }

  getWorkshopsList = query => {
    return new HttpClient().get(GET_WORKSHOPS + query).then(data => data.body.data.workshops);
  }

  getProviderSuggestions = async value => {
    const inputValue = value.trim().toLowerCase();
    const data = await this.getUsersList(inputValue);
    return data;
  };

  getWorkshopSuggestions = async value => {
    const inputValue = value.trim().toLowerCase();
    const data = await this.getWorkshopsList(inputValue);
    return data;
  };

  getSuggestionProviderValue = suggestion => {
    this.setState({selectedId: suggestion.id});
    return `${suggestion.first_name} ${suggestion.last_name}`;
  };

  getSuggestionWorkshopValue = suggestion => {
    this.setState({selectedId: suggestion.id});
    return suggestion.title;
  };

  downloadCSV = blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${moment(this.state.date).format('DD_MM_YYYY')}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  apply = () => {
    const {providerReport, date, selectedId} = this.state;
    let headers = new Headers();
    headers.append("Authorization", `Token token=${localStorage.token}`);
    if(!date) {
      this.props.alert.error("Please select date");
    } else if(!selectedId) {
      this.props.alert.error(`Please select ${providerReport ? 'Provider' : 'Workshop'}`);
    } else if(providerReport) {
      fetch(GET_PROVIDER_EXPORT + `date=${moment(date).toISOString()}&provider_id=${selectedId}`, {
        method: 'GET',
        headers,
      })
      .then(response => {
        response.blob()
        .then(blob => this.downloadCSV(blob))
      })
    } else {
      fetch(GET_WORKSHOP_EXPORT + `date=${moment(date).toISOString()}&workshop_id=${selectedId}`, {
        method: 'GET',
        headers,
      })
      .then(response => {
        response.blob()
        .then(blob => this.downloadCSV(blob))
      })
    }
  }

  renderProviderSuggestion = suggestion => (
    <div>
      {`${suggestion.first_name} ${suggestion.last_name}`}
    </div>
  );

  renderWorkshopSuggestion = suggestion => (
    <div>
      {suggestion.title}
    </div>
  );

  render() {
    const {providerReport, provider, workshop, providers, workshops} = this.state;
    const inputProps = {
      placeholder: providerReport ? 'Choose provider' : 'Choose workshop',
      value: providerReport ? (provider || '') : (workshop || ''),
      onChange: providerReport ? this.handleProviderChange : this.handleChangeWorkshop
    };
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        width: '100%',
      }}>
        <div className="row" style={{margin: '16px auto'}}>
          <div className="col-12">
            <div className="accordion-content-block">
              {/* <p className="label">Online Workshop Or Regular (Offline) Workshop Or Live Webinar?</p> */}
              <span className={providerReport ? "btn bordered empty grey-empty" : "btn bordered prime"} onClick={this.onWorkshop}>Workshop</span>
              <span className={providerReport ? "btn bordered prime" : "btn bordered empty grey-empty"} style={{marginLeft: 10}} onClick={this.onProvider}>Provider</span>
            </div>
          </div>

        </div>
        <div className="row" style={{position: 'relative', margin: '16px auto'}}>
          <SingleDatePicker
            enableOutsideDays={true}
            isOutsideRange={() => false}
            showClearDate={true}
            displayFormat={'DD/MM/YYYY'}
            placeholder="Choose a date"
            date={this.state.date || null}
            numberOfMonths={1}
            onDateChange={(startDate) => {
              this.setState({focusedInput: false, date: startDate})
              }
            }
            focused={this.state.focusedInput}
            onFocusChange={ () => {
                this.setState({focusedInput: !this.state.focusedInput})
            }}
          />
        </div>
        <div className="row" style={{margin: '16px auto'}}>
          {providerReport ?
            <div className='col-12'>
              <Autosuggest
                suggestions={providers}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionProviderValue}
                renderSuggestion={this.renderProviderSuggestion}
                inputProps={inputProps}
              />
            </div> :
            <div className='col-12'>
              <Autosuggest
                suggestions={workshops}
                onSuggestionsFetchRequested={this.onSuggestionsFetchWorkshops}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionWorkshopValue}
                renderSuggestion={this.renderWorkshopSuggestion}
                inputProps={inputProps}
              />
            </div>
          }
        </div>
        <div className="row" style={{margin: '16px auto'}}>
          <span className="btn prime bordered" onClick={this.apply}>Apply</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/index.jsx